export interface Suggest_Interface {
  id:number,
  title:String,
  title_id:number,
  dsc:String,
  persianDate:String,
  username: String,
  file:Array<string>

  last_persianDate: String,
  last_status: String,
  last_dsc: String,
}

export function Empty_Suggest_Interface():Suggest_Interface{
  return{
    id:0,
    title:'',
    title_id:0,
    dsc:'',
    persianDate:'',
    username: '',
    file: [],

    last_persianDate: '',
    last_status: '',
    last_dsc: '',
  }
}
